function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { BASE_URL } from '@paperstac/env';
import { accountByIdRef } from '@paperstac/firestore-collections/lib/accounts';
import { accountsByIdentityIdRef } from '@paperstac/firestore-collections/lib/accounts';
import { getDomainFromBaseUrl } from '@paperstac/helpers/lib/domain';
import createPersistedState from '@paperstac/hooks/lib/createPersistedState';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { getSessionCurrentAccountId, setSessionCurrentAccountId } from '../services/session';
import { getStateStorageAdapter } from '../services/statePersistence';
import { IdentityContext } from './IdentityProvider';
var useAccountsState = createPersistedState('AccountsProviderAccounts', getStateStorageAdapter());
var useCurrentAccountIdState = createPersistedState('AccountsProviderCurrentAccountId', getStateStorageAdapter());
var AccountsContext = /*#__PURE__*/React.createContext();
var Provider = AccountsContext.Provider;
var DEFAULT_STATE = {
  currentAccountId: null,
  accounts: null
};
var AccountsProvider = /*#__PURE__*/React.memo(function (_ref) {
  var domain = _ref.domain,
    children = _ref.children;
  var _React$useContext = React.useContext(IdentityContext),
    uid = _React$useContext.uid,
    claims = _React$useContext.claims;
  var _useAccountsState = useAccountsState(DEFAULT_STATE.accounts),
    _useAccountsState2 = _slicedToArray(_useAccountsState, 2),
    accounts = _useAccountsState2[0],
    setAccounts = _useAccountsState2[1];
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    impersonatedAccount = _React$useState2[0],
    setImpersonatedAccount = _React$useState2[1];
  var _useCurrentAccountIdS = useCurrentAccountIdState(DEFAULT_STATE.currentAccountId),
    _useCurrentAccountIdS2 = _slicedToArray(_useCurrentAccountIdS, 2),
    currentAccountId = _useCurrentAccountIdS2[0],
    setCurrentAccountId = _useCurrentAccountIdS2[1];
  var isAdmin = get(claims, 'admin', false);
  var handleCurrentAccountId = React.useCallback(function (currentAccountId) {
    setSessionCurrentAccountId(currentAccountId);
    setCurrentAccountId(currentAccountId);
  }, []);
  React.useEffect(function () {
    if (uid && currentAccountId && currentAccountId !== getSessionCurrentAccountId()) {
      setSessionCurrentAccountId(currentAccountId);
    }
  }, [uid, currentAccountId, getSessionCurrentAccountId()]);
  React.useEffect(function () {
    if (!uid) {
      setAccounts(DEFAULT_STATE.accounts);
      setCurrentAccountId(DEFAULT_STATE.currentAccountId);
      return;
    }
    return accountsByIdentityIdRef(uid).where('domain', '==', domain).onSnapshot(function (qs) {
      var accounts = qs.docs.map(function (ds) {
        return ds.data();
      });
      setAccounts(accounts);
      if (accounts.length === 1) handleCurrentAccountId(accounts[0].id);
    });
  }, [uid]);
  React.useEffect(function () {
    if (!isAdmin || !currentAccountId || !Array.isArray(accounts) || !!accounts.find(function (_ref2) {
      var id = _ref2.id;
      return id === currentAccountId;
    })) {
      setImpersonatedAccount(null);
      return;
    }
    return accountByIdRef(currentAccountId).onSnapshot(function (docSnap) {
      return setImpersonatedAccount(docSnap.data());
    });
  }, [isAdmin, accounts, currentAccountId]);
  var state = React.useMemo(function () {
    var accountsAndImpersonated = impersonatedAccount ? [impersonatedAccount].concat(_toConsumableArray(accounts)) : accounts;
    return {
      accounts: accountsAndImpersonated,
      currentAccountId: currentAccountId,
      currentAccount: !accounts || !currentAccountId ? null : accountsAndImpersonated.find(function (_ref3) {
        var id = _ref3.id;
        return id === currentAccountId;
      }) || null,
      setCurrentAccountId: handleCurrentAccountId
    };
  }, [accounts, currentAccountId, impersonatedAccount]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: state
  }, children);
});
AccountsProvider.propTypes = {
  children: PropTypes.element.isRequired,
  domain: PropTypes.string.isRequired
};
AccountsProvider.defaultProps = {
  domain: getDomainFromBaseUrl(BASE_URL)
};
export default AccountsProvider;
var withAccounts = function withAccounts(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(AccountsContext.Consumer, {
      children: function children(contexts) {
        return /*#__PURE__*/React.createElement(Component, _extends({}, props, contexts));
      }
    });
  };
};
export { AccountsContext, withAccounts };